import React from 'react';
import { Button } from '@mui/material';

function statusColor(status) {
  const s = (status || '').toLowerCase();
  if (s === 'draft') return 'info';
  if (s === 'sending') return 'warning';
  if (s === 'failed') return 'error';
  return 'success';
}

function statusLabel(status) {
  if (!status) return 'Sent';
  return status.charAt(0).toUpperCase() + status.slice(1);
}

/**
 * Read-only status pill using semantic MUI colors (Email analytics header).
 */
export default function CampaignStatusButton({ status, ...props }) {
  return (
    <Button variant="contained" color={statusColor(status)} size="small" {...props}>
      {statusLabel(status)}
    </Button>
  );
}
